<template>
  <div v-if="isLoaded">
    <vue-headful v-if="page.fields.seo" :title="page.fields.seo.seo_title"
      :description="page.fields.seo.meta_description" />
    <SeoSchema v-if="page.fields.seo" :json="page.fields.seo.schema" />
    <Breadcrumbs :items="page.fields.breadcrumbs" />
    <HeroVideo :hero="this.hero" />
    <ExperienceHeader :experience="experience" />
    <ExperienceArticles :categorySlug="categorySlug" :articleTitle="experience.articleTitle" :articleContent="experience.articleContent" />
    <ExperienceFeaturedEvents2 :featuredEvents="experience.featuredEvents"
      :featuredEventsTitle="experience.featuredEventsTitle"
      :featuredEventsDescription="experience.featuredEventsDescription"
      ariaLabel="Alabama Civil Rights Featured Events" experience="5" />
    <ExperiencePodcast :podcastSectionTitle="experience.podcastSectionTitle"
      :podcastSectionDesc="experience.podcastSectionDesc" :podcastSectionSubTitle="experience.podcastSectionSubTitle"
      :podcastSectionSubDesc="experience.podcastSectionSubDesc" :podcastTitle="experience.podcastTitle"
      :podcast="experience.podcast" ariaLabel="Alabama Civil Rights Podcast" />
    <ExperienceUpcomingEvents2 v-if="experience.upcomingEvents" :upcomingEvents="experience.upcomingEvents"
      :upcomingEventsTitle="experience.upcomingEventsTitle"
      :upcomingEventsDescription="experience.upcomingEventsDescription" />
    <ExperienceDestinations2 v-if="experience.destinationBackgroundImageUrl"
      :experienceType="experience.destinationsTitle" :buttonText="experience.destinationsButtonText"
      :buttonLink="experience.destinationsButtonLink" :experienceDescription="experience.destinationsDescription"
      mapDestinationType="Attraction" :destinations="experience.destinations" slug="civil"
      :destinationBackgroundImageUrl="experience.destinationBackgroundImageUrl" />
    <ExperienceList v-on:reloadExperiencesMap="reloadExperiencesMap" v-if="experience && experience.locations && loaded"
      :experienceTitle="experience.title ? experience.title : ''" :locations="experience.locations"
      :headline_title="page.fields.headline_title" :headline_text="page.fields.headline_text"
      mapDestinationType="Civil-Rights-Legacy" ariaLabel="Find an Alabama Civil Rights Experience" class="park-mb-100" />
    <TripIdeas2 class="" experience="5" />
    <section class="featured-exp" v-if="experience.featuredExperience.length" >
      <FeaturedExperiences v-for="(exp, index) in experience.featuredExperience" :key="index"
        :index="index" :title="exp.name" :description="exp.description" :link="exp.url" :link_text="''"
        :image="exp.image" :imageAlt="exp.image_alt_text" :reversed="!!(index % 2)" />
    </section>
    <Intersect @enter.once="isCrowdriffLoaded = true" @leave.once="isCrowdriffLoaded = false">
      <span>
        <Crowdriff v-if="isCrowdriffLoaded" :id="page.fields.crowdriff_gallery.id"
          :aria-label="page.fields.crowdriff_gallery.aria_label" :title="page.fields.crowdriff_gallery.title"
          :intro="page.fields.crowdriff_gallery.intro" />
      </span>
    </Intersect>
    <AttractionFilter :experienceId="5" />
    <Feedback pageType="page" />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import Butter from 'buttercms';
import ExperienceHeader from '@/components/Experiences/Common/ExperienceHeader.vue';
import ExperienceFeaturedEvents2 from '@/components/Experiences/Common/ExperienceFeaturedEvents2.vue';
import ExperienceUpcomingEvents2 from '@/components/Experiences/Common/ExperienceUpcomingEvents2.vue';
import Crowdriff from '@/components/Common/Crowdriff.vue';
import TripIdeas2 from '@/components/PlacesToGo/Common/TripIdeas2.vue';
import AttractionFilter from '@/components/PlacesToGo/Common/AttractionFilter.vue';
import ExperienceDestinations2 from '@/components/Experiences/Common/ExperienceDestinations2.vue';
import ExperienceList from '@/components/Experiences/Common/ExperienceList.vue';
import ExperiencePodcast from '@/components/Experiences/Common/ExperiencePodcast.vue';
import Intersect from 'vue-intersect';
import Breadcrumbs from '@/components/Common/Breadcrumbs.vue';
import HeroVideo from './Common/HeroVideo.vue';
import ExperienceArticles from './Common/ExperienceArticles.vue';
import FeaturedExperiences from './Common/FeaturedExperiences.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  components: {
    ExperienceHeader,
    ExperienceFeaturedEvents2,
    ExperienceUpcomingEvents2,
    Crowdriff,
    TripIdeas2,
    AttractionFilter,
    ExperienceDestinations2,
    ExperienceList,
    ExperiencePodcast,
    Breadcrumbs,
    HeroVideo,
    ExperienceArticles,
    Intersect,
    FeaturedExperiences,
  },
  data() {
    return {
      page: {
        fields: {},
      },
      breadcrumbs: [],
      categorySlug: 'civil-rights-legacy',
      isLoaded: false,
      loaded: false,
      experience: {
        slug: 'civil',
        title: null,
        iconName: null,
        content: null,
        imageUrl: null,
        imageAlt: null,
        imageCaption: null,
        imageLink: null,
        featuredEvents: [{}],
        featuredEventsTitle: null,
        featuredEventsDescription: null,
        upcomingEventsTitle: null,
        upcomingEventsDescription: null,
        upcomingEvents: [{}],
        destinations: [{}],
        destinationsButtonText: null,
        destinationsButtonLink: null,
        destinationsTitle: null,
        destinationsDescription: null,
        destinationBackgroundImageUrl: null,
        locations: [],
        featuredExperience: [{}],
        podcastSectionTitle: null,
        podcastSectionDesc: null,
        podcastSectionSubTitle: null,
        podcastSectionSubDesc: null,
        podcastTitle: null,
        articleTitle: null,
        articleContent: null,
      },
      hero: {},
    };
  },
  methods: {
    reloadExperiencesMap(bounds) {
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const params = `&min_latitude=${sw.lat()}&min_longitude=${ne.lng()}&max_latitude=${ne.lat()}&max_longitude=${sw.lng()}`;
      this.getExperienceLocations(params);
    },
    getPage() {
      butter.page.retrieve('*', 'civil-rights-legacy', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
          this.breadcrumbs = this.page.fields.breadcrumbs || this.breadcrumbs;
          this.isLoaded = true;
          this.experience.content = this.page.fields.description;
          this.experience.title = this.page.fields.title;
          this.experience.imageCaption = this.page.fields.hero_image_location;
          this.experience.imageLink = this.page.fields.hero_image_url;
          this.experience.destinationsButtonText = this.page.fields.destinations_button_text;
          this.experience.destinationsButtonLink = this.page.fields.destinations_button_link;
          this.experience.imageAlt = this.page.fields.hero_image_alt;
          this.experience.iconName = this.page.fields.experience_image;
          this.experience.imageUrl = this.page.fields.hero_image;
          this.experience.featuredEventsTitle = this.page.fields.featured_events_title;
          this.experience.featuredEventsDescription = this.page.fields.featured_events_description;
          this.experience.upcomingEventsTitle = this.page.fields.upcoming_events_title;
          this.experience.upcomingEventsDescription = this.page.fields.upcoming_events_description;
          this.experience.featuredEvents = this.page.fields.featured_events;
          this.experience.destinations = this.page.fields.destinations;
          this.experience.destinationsTitle = this.page.fields.destinations_title;
          this.experience.destinationsDescription = this.page.fields.destinations_description;
          this.experience.destinationBackgroundImageUrl = this.page.fields.destinations_background;
          this.experience.featuredExperience = this.page.fields.featured_experiences;
          this.experience.podcastSectionTitle = this.page.fields.podcast_section_title;
          this.experience.podcastSectionDesc = this.page.fields.podcast_section_desc;
          this.experience.podcastSectionSubTitle = this.page.fields.podcast_section_sub_title;
          this.experience.podcastSectionSubDesc = this.page.fields.podcast_section_sub_desc;
          this.experience.podcastTitle = this.page.fields.podcast_title;
          this.experience.podcast = this.page.fields.podcast;
          this.experience.articleTitle = this.page.fields.article.article_title;
          this.experience.articleContent = this.page.fields.article.article_content;
          // Hero Video
          this.hero.image = this.page.fields.hero_image;
          this.hero.imageAlt = this.page.fields.hero_image_alt;
          this.hero.video = this.page.fields.hero_video;
          this.hero.type = 'video/mp4';
        }).catch((res) => {
          console.log(res);
        });
    },
    async getExperienceLocations(params) {
      await axios.get(`${process.env.VUE_APP_API2}filterLocations?experience_types=5${params}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      }).then((response) => {
        this.$nextTick(() => {
          const { locations } = response.data;
          let count = locations.length;
          let temp;
          let index;
          // shuffle
          while (count > 0) {
            // Pick a random index
            index = Math.floor(Math.random() * count);
            // Decrease count by 1
            count--;
            // And swap the last element with it
            temp = locations[count];
            locations[count] = locations[index];
            locations[index] = temp;
          }
          this.experience.locations = locations.map(location => ({ ...location, show: true }));
          this.loaded = true;
        });
      });
    },
  },
  async created() {
    await this.getPage();
    await this.getExperienceLocations('');
    await this.$store.dispatch('maps/setExperienceType', 5);
    await this.$store.dispatch('maps/setArea', '');
    await this.GetExperienceUpcomingEvents();
  },
})
class CivilRightsDetail extends Vue {
  async GetExperienceUpcomingEvents() {
    const response = await axios.get(`${process.env.VUE_APP_API2}searchEvents?experience_types=5`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
      },
    });
    this.experience.upcomingEvents = response.data.events;
  }
}

export default CivilRightsDetail;
</script>

<style scoped>
.featured-exp {
  max-width: 1280px;
  margin: 0 auto;
}</style>
